module.exports = __webpack_public_path__ + "img/x.8805c1f7.svg";